<template>
<v-app>
    <div class="app">
        <div class="pa-20">
            <div class="navbar">
                <a href="#/epspi" class="nav_title">EPS Pi</a>
                <a href="http://www.ebmtech.com/en/about/index.php" target="_blank" class="sm-none">{{ $t("epspi.about") }}</a>
                <a href="http://www.ebmtech.com/en/contact/index.php" target="_blank" class="sm-none">{{ $t("epspi.contact") }}</a>
            <div class="float-r mr-30"> 
                <a href="https://www.facebook.com/ebmtech" target="_blank" class="xs-none">
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/fb.png" >
                    </v-btn>
                </a>
                <a href="https://www.linkedin.com/company/14425711/admin/" target="_blank" class="xs-none">
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/li.png" >
                    </v-btn>
                </a>
                <a href="https://twitter.com/EBM_Tech" target="_blank" class="xs-none">
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/tw.png" >
                    </v-btn>
                </a>
                <a href="https://www.youtube.com/c/Ebmtech" target="_blank" class="xs-none">
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/yt.png" >
                    </v-btn>
                </a>
                <a :href="`${publicPath}eps_pi_en.pdf`" download="EPS Pi" class="outline" v-if="lang =='en'">
                    <v-btn class="mr-1" color="#133269" dark>
                    <p class="mb-0 text-capitalize">{{ $t("epspi.download") }}</p>
                </v-btn>
                </a>
                <a :href="`${publicPath}eps_pi_ch.pdf`" download="EPS Pi" class="outline" v-if="lang =='ch'">
                    <v-btn class="mr-1" color="#133269" dark>
                    <p class="mb-0 text-capitalize">{{ $t("epspi.download") }}</p>
                </v-btn>
                </a>
                <v-btn class="mr-1" icon @click="language" style="margin-right:5px">
                <p style="font-size:18px; margin-top:10px">{{langval}}</p>
                </v-btn>
            </div>
            </div>
        </div>
            <img src="@/assets/epspi/eps_pi_en.png" width="100%" height="auto" v-if="lang == 'en'">
            <img src="@/assets/epspi/eps_pi_ch.png" width="100%" height="auto" v-if="lang == 'ch'">
        <div>
            <eps-pi-contact-form></eps-pi-contact-form>
            <div class="navbar xs-block center">
            <div> 
                <a href="https://www.facebook.com/ebmtech" target="_blank" >
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/fb.png" >
                    </v-btn>
                </a>
                <a href="https://www.linkedin.com/company/14425711/admin/" target="_blank" >
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/li.png" >
                    </v-btn>
                </a>
                <a href="https://twitter.com/EBM_Tech" target="_blank" >
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/tw.png" >
                    </v-btn>
                </a>
                <a href="https://www.youtube.com/c/Ebmtech" target="_blank" >
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/yt.png" >
                    </v-btn>
                </a>
            </div>
            </div>
        </div>
        <div class="footer">
            <p class="footer-h center"> 2022 EBM Technologies. All Rights Reserved.</p>
        </div>
    </div>
</v-app>
</template>
<script>
import EpsPiContactForm from './EpsPiContactForm.vue';
export default {
  components: {
    EpsPiContactForm
    },
    metaInfo() {
        return { 
            title: "EPS-Pi",
            meta: [
                { name: 'description', content:  'A Viewer Ready DICOM Device.'},
            ]
        }
    },
    created(){
        let lang = localStorage.getItem('lang')
        lang == 'en' ? this.langval = '中' : this.langval = 'EN'
        if(lang =='en'){
                this.$i18n.locale = 'en'
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }else {
            console.log("chinese");
            this.$i18n.locale = 'ch'
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }
        
    },
  data:function(){
        const lang = localStorage.getItem('lang')
        return{
            publicPath: process.env.BASE_URL,
            lang:lang,
            langval:''
        }
  },
  methods: {
    language(){
        if(this.langval=='EN'){
            this.$i18n.locale = 'en'
            localStorage.setItem('lang','en');
            this.langval='中'
        }
        else{
            this.$i18n.locale = 'ch'
            localStorage.setItem('lang','ch');
            this.langval='EN'
        }
        window.location.reload()
    },
  },
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600&display=swap');
* {
  font-family: Raleway;
}
.app{
    width: 100%;
    height: 100%;
    background: white;
    color: #133269;
}
.center{
    text-align: center;
}
.navbar a {
  /* float: left; */
  color: #133269;
  text-align: center;
  margin: 1px 16px;
  text-decoration: none;
  font-size: 18px;
  line-height: 21px;
  transition: 0.5s;
}
.navbar .xs-none {
  margin: 1px 4px;
}
.navbar .outline{
    margin: 1px 4px;
}
.nav_title{
    font-family: 'Helvetica';
font-style: normal;
font-weight: 700;
font-size: 24px;
line-height: 28px;
}
.navbar a:hover {
  color: #002E81;
}
.float-r{
    float: right;
}
.mr-30{
    margin-right: 30px;
}
.pa-20{
    padding: 20px;
}
.icon{
    width: 34px;
    height: 34px;
}
.xs-block{
    display: none;
}
.eps_image{
    height: 100%;
    width: 100%;
}
.footer{
    height: 47px;
    background: #133269;
    }
.footer-h{
    color: white;
    padding-top: 16px;
    margin-top: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
}
@media screen and (max-width: 955px){
.sm-none{
    display: none;
}}
@media screen and (max-width: 548px){
    .mr-30{
        margin-right: 0;
    }
.xs-block{
    display: block;
}
.xs-none{
    display: none;
}
}

</style>